import { indexRoute } from './utils';

const allowedParams = ['clientId'];

const templates = {
    index: indexRoute('/templates/notifications'),
};

export default templates;